<app-layout [dir]="textDir" [languageList]="languageList" [templateType]="layoutTemplateType"></app-layout>
<app-loading *ngIf="loadingService.isLoading(loaderEnum.MAIN)" [id]="loaderEnum.MAIN"
             backdrop-position="relative"></app-loading>